import chain from '@/lib/axios-chain'

// 获取EDM邮件数量
export const getEmailNum = () => chain.create('/edm/email/getNum', 'get')

// 邮件列表
export const getEmailList = () => chain.create('/edm/email/index', 'get')

// 删除邮件
export const delEmail = () => chain.create('/edm/email/del', 'post')

// 删除清单联系人
export const delContactList = () => chain.create('/edm/contact/delContactList', 'post')

// 创建/修改清单
export const editContact = () => chain.create('/edm/contact/createContact', 'post')

// 删除清单
export const delContact = () => chain.create('/edm/contact/delContact', 'post')

// 清单联系人列表
export const getContactlist = () => chain.create('/edm/contact/getContactlist', 'get')

// 导入清单联系人
export const importContact = () => chain.create('/edm/contact/import', 'post')

// 清单列表
export const getContact = () => chain.create('/edm/contact/index', 'get')

// 邮件列表筛选项-清单名称列表
export const getContactName = () => chain.create('/edm/email/getContactName', 'get')

// 发送报告
export const getStatistics = () => chain.create('/edm/email/statistics', 'get')

// 添加邮件
export const addEmail = () => chain.create('/edm/email/add', 'post')

// 编辑清单添加联系人时候获取EDM筛选条件
export const getEdmQuery = () => chain.create('/inquiry/config/getedmquery', 'get')

// 获取邮件详情 - 编辑邮件时候使用
export const getEmailInfo = () => chain.create('/edm/email/emailInfo', 'get')

// 邮件复制
export const copyEmail = () => chain.create('/edm/email/copy', 'get')

// 邮件事件列表-发送报告
export const getEmailEventList = () => chain.create('/edm/email/eventList', 'get')

// 获取邮件的触发条件 - 编辑邮件时候用到
export const getTriggerCondition = () => chain.create('/edm/email/getTriggerCondition', 'get')

// 测试邮件
export const testSend = () => chain.create('/edm/email/testSend', 'post')

// 清单联系人导入功能筛选联系人数量
export const getEdmQueryCount = () => chain.create('/inquiry/config/edmquerycount', 'post')

// 联系人筛选结果导入联系人清单
export const setEdmQueryResult = () => chain.create('/inquiry/config/edmqueryresult', 'post')

// 邮件名称列表 - 发送报告的邮件下拉切换使用
export const getTaskNameList = () => chain.create('/edm/email/getTaskNameList', 'get')

// 购买邮件 支付
export const payEmail = () => chain.create('/config/pay', 'post')
